// Display-only hooks; no prices, cart lines, subscriptions or checkout handlers.
(() => {
 const reviews=document.querySelector('#judgeme_product_reviews');
 if(reviews&&location.hash.includes('KindVeilReviewTitle'))requestAnimationFrame(()=>reviews.scrollIntoView({block:'start'}));
 const labelShades=()=>{
  const image=document.querySelector('.multicolumn img[src*="kind-veil-shade-match-visual-logo-fixed-v2"]');
  const wrapper=image?.closest('.multicolumn-card__image-wrapper');
  if(!wrapper||wrapper.querySelector('.kv-native-shade-labels'))return;
  wrapper.classList.add('kv-native-shade-media');
  const labels=document.createElement('div');labels.className='kv-native-shade-labels';
  for(const shade of ['Ivory White','Natural Color','Wheat Color','Coffee Color']){const span=document.createElement('span');span.textContent=shade;labels.appendChild(span);}
  wrapper.appendChild(labels);
 };labelShades();document.addEventListener('shopify:section:load',labelShades);
 document.addEventListener('click',event=>{
  if(!event.target.closest?.('#cart-icon-bubble'))return;
  const drawer=document.querySelector('theme-drawer#cart-drawer');
  if(typeof drawer?.open==='function'){event.preventDefault();event.stopImmediatePropagation();drawer.open();}
 },true);
 document.addEventListener('shopify:cart:lines-update',event=>{
  event.promise?.then(result=>{
   const count=result.cart?.totalQuantity??result.detail?.itemCount;
   if(count===undefined)return;
   const link=document.getElementById('cart-icon-bubble');if(!link)return;
   let bubble=link.querySelector('.cart-count-bubble');
   if(!bubble){bubble=document.createElement('div');bubble.className='cart-count-bubble';link.appendChild(bubble);}
   bubble.textContent=String(count);bubble.hidden=count===0;
  }).catch(()=>{});
 });
})();
